/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import NavigationMenu from './NavigationMenu';
import DataForgeIcon from 'icons/DataForgeIcon';
import DataSuitesItem from 'components/navigation/side-navigation/menu/data-suites/DataSuitesItem';
import DashboardsItem from 'components/navigation/side-navigation/menu/data-suites/DashboardsItem';
import ArtisanItem from 'components/navigation/side-navigation/menu/data-suites/ArtisanItem';
import TransferAdaptersItem from 'components/navigation/side-navigation/menu/data-suites/TransferAdaptersItem';

const messages = defineMessages({
  title: {id: 'navigation.data-forge'},
});

const DataForgeMenu = () => (
  <NavigationMenu
    iconBefore={DataForgeIcon}
    route="midas/data-forge"
    title={messages.title}
  >
    <DataSuitesItem />
    <DashboardsItem />
    <ArtisanItem />
    <TransferAdaptersItem />
  </NavigationMenu>
);

export default DataForgeMenu;
